import React, { useMemo } from "react";
import { AauxNextFonts } from "../../fonts";
import { FontFace } from "csstype";
import { Box, BoxProps } from "@material-ui/core";

const supportedFontWeights = (fonts: FontFace[]) => {
  return new Set(
    fonts.filter((font) => font.fontWeight).map((font) => font.fontWeight),
  );
};

interface InlineTypeProps extends BoxProps {
  textDecoration?: TextDecoration;
}

export const TEXT_DECORATIONS = [
  "overline",
  "line-through",
  "underline",
  "underline overline",
];
type TextDecoration = typeof TEXT_DECORATIONS[number];

export const InlineType: React.FC<InlineTypeProps> = ({
  children,
  fontWeight,
  textDecoration,
  ...rest
}) => {
  const fontWeights = useMemo(() => supportedFontWeights(AauxNextFonts), []);
  const appliedFontWeight = useMemo(() => {
    if (!fontWeight) {
      return undefined;
    }
    if (fontWeight !== "bold" && !fontWeights.has(fontWeight)) {
      console.warn(`Provided font weight ${fontWeight} is not supported`);
      return undefined;
    }
    return fontWeight;
  }, [fontWeights, fontWeight]);

  return (
    <Box
      component="span"
      fontWeight={appliedFontWeight}
      style={{ textDecoration }}
      {...rest}
    >
      {children}
    </Box>
  );
};
